import { Box, Button, Grid } from "@mui/material"
import { useFormContext } from "react-hook-form"
import DisplayNotFoundInfo from "../../../../../../components/DisplayNotFindInfo"
import { TableSimples } from "../../../../../../components/BasicComponents/DisplayDados/TableSimples"
import { formatarValorMonetario } from "../../../../../../helpers/masks"
import moment from "moment"

export default function Step02() {

  const { handleSubmit, getValues } = useFormContext()

  const onSubmit = getValues('funcoesAux.onSubmit')
  const handleBack = getValues('funcoesAux.onBack')
  const titulosSelecionados: any[] = getValues('selecionar_titulos')

  const handleAvancar = (data: any) => {

    onSubmit(data)
  }

  return (
    <>
      <Grid container justifyContent='space-between' paddingTop={3}>
        <Grid size={{xs: 12}}>
          {
            titulosSelecionados.length <= 0 &&
            <DisplayNotFoundInfo label="Nenhum título selecionado" />
          }
          {
            titulosSelecionados.length > 0 &&
            <Grid container spacing={2}>

              <Grid size={{xs: 12, md: 12}}>
                <TableSimples
                  headers={[
                    { label: "Título" },
                    { label: "Público" },
                    { label: "Data Vencimento" },
                    { label: "Saldo", numeric: true },
                  ]}
                  rows={titulosSelecionados.map(row => ({
                    columns: [
                      { value: `${row.tipo_documento}-${row.numero_documento}/${row.sequencia_documento}` },
                      { value: `${row.tipo_publico}${row.codigo_publico} - ${row.nome_publico}` },
                      { value: `${moment(row.data_vencimento).format('DD/MM/YYYY')}` },
                      { value: row.saldo_principal, monetary: true, numeric: true },
                    ]
                  }))}
                  total={{
                    label: "Total",
                    value: formatarValorMonetario(titulosSelecionados.reduce((total, row) => total + row.saldo_principal, 0))
                  }}
                />
              </Grid>
            </Grid>
          }
        </Grid>


      </Grid>

      <Box width={'100%'} display={'flex'} justifyContent={'flex-end'} gap={2} mt={2}>

        <Button
          onClick={handleBack}
        >
          Voltar
        </Button>

        <Button
          variant="contained"
          onClick={handleSubmit(handleAvancar)}
        >
          Solicitar
        </Button>
      </Box>
    </>
  )
}
